import React, { useContext, useEffect, useState } from "react";
import { Typography, Box, Grid, Card, CardContent, Button } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom"; // For navigation
import { AuthContext } from "../../context/AuthContext";
import { getShipments, getGPSData, getAllDeviceInfo, getGeoFence, getProfileInfo } from "../../services/api"; // Import API services

const Dashboard = () => {
    const { auth, logout } = useContext(AuthContext);
    const [shipments, setShipments] = useState([]);
    const [getAllDeviceInfos, setgetAllDeviceInfos] = useState([]);
    const [getGeoFences, setgetGeoFences] = useState();
    const navigate = useNavigate();
    const location = useLocation();
    const [username, setUsername] = useState("");

    useEffect(() => {
        if (auth) {
            fetchShipments();
            // fetchAllDeviceInfo();
            fetchGeoFence();
            fetchProfile();
        }
    }, [auth]);

    const fetchShipments = async () => {
        const data = await getShipments(auth);
        setShipments(data);
    };

    const fetchProfile = async () => {
        console.log("Calling getProfileInfo...");
        const data = await getProfileInfo(auth);
        if (data?.username) {
            setUsername(data.username);
        }
    };


    const fetchAllDeviceInfo = async () => {
        const data = await getAllDeviceInfo(auth);
        setgetAllDeviceInfos(data);
    }

    const fetchGeoFence = async () => {
        const data = await getGeoFence(auth);
        setgetGeoFences(data);
    }

    // ✅ Handle browser back button
    useEffect(() => {
        const handleBackButton = (event) => {
            event.preventDefault(); // Prevent default navigation

            const confirmLogout = window.confirm("You will be logged out. Are you sure?");
            if (confirmLogout) {
                logout(); // Clear session and logout
                navigate("/login", { replace: true }); // Redirect to login page
            }
        };

        window.addEventListener("popstate", handleBackButton);

        return () => {
            window.removeEventListener("popstate", handleBackButton);
        };
    }, [navigate, logout]);

    // ✅ Handle View Click (Fetch GPS Data & Redirect)
    const handleViewClick = async (shipmentId) => {
        console.log("Fetching GPS data for shipment:", shipmentId);
        const gpsData = await getGPSData(auth, shipmentId);

        if (gpsData) {
            console.log("GPS Data fetched successfully:", gpsData);
            navigate(`/gps/${shipmentId}`, { state: { gpsData } });
        } else {
            console.error("Failed to fetch GPS data.");
        }
    };

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h4" sx={{ mb: 3 }}>Dashboard</Typography>

            {/* Active Shipments */}
            <Typography variant="h6" sx={{ mb: 2 }}>📦 Active Shipments</Typography>

            {/* Shipment Cards View */}
            <Grid container spacing={3}>
                {shipments.length > 0 ? (
                    shipments.map((shipment) => (
                        <Grid item xs={12} sm={6} md={5} key={shipment.id}>
                            <Card sx={{ boxShadow: 3, borderRadius: 2, p: 2 }}>
                                <CardContent>
                                    <Typography variant="h7" gutterBottom>
                                        Device Id:
                                    </Typography>
                                    <Typography variant="h7" gutterBottom>
                                        {shipment.device.code}
                                    </Typography>
                                    <Typography variant="h6" gutterBottom>
                                        🆔 Shipment ID: {shipment.shipmentId}
                                    </Typography>
                                    <Typography variant="body1">
                                        <strong>Shipment Code:</strong> {shipment.shipmentCode}
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary">
                                        <strong>Status:</strong> {shipment.status}
                                    </Typography>
                                </CardContent>
                                <Button
                                    variant="contained"
                                    sx={{ m: 2 }}
                                    onClick={() => handleViewClick(shipment.shipmentId)}
                                >
                                    View
                                </Button>
                            </Card>
                        </Grid>
                    ))
                ) : (
                    <Typography>No active shipments found.</Typography>
                )}
            </Grid>
        </Box>
    );
};

export default Dashboard;
